module.exports = __webpack_public_path__ + "img/appLogOutBordeless.df5b1dc0.png";